// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Haiti from '../_raw/flag/icon_flag_haiti.png';

export default () => <img src={Haiti} alt="Haiti" />;
